{
  "jobLabel": "Course",
  "close": "Fermer",
  "cancel": "Annuler",
  "cancelled": "Annulée",
  "onHold": "En attente",
  "ok": "OK",
  "allow": "Autoriser",
  "confirm": "Confirmer",
  "dismiss": "Ignorer",
  "pleaseWait": "Veuillez patienter...",
  "about": "À propos",
  "version": "Version",
  "callUs": "Appelez-nous",
  "emailUs": "Écrivez-nous",
  "privacyPolicy": "Politique de confidentialité",
  "termsOfService": "Conditions d'utilisation",
  "profile": "Profil",
  "contact": "Contact",
  "editProfile": "Modifier le profil",
  "menu": "Menu",
  "paymentCards": "Cartes de paiement",
  "address": "Adresse",
  "pointOfInterest": "Point d'intérêt",
  "myAddresses": "Mes adresses",
  "operatorLogo": "Logo de l'opérateur",
  "search": "Rechercher",
  "goodsTypes": {
    "passenger": "Passager | Passagers",
    "passengers": "1 passager | {count} passagers",
    "parcel": "Colis | Colis",
    "parcels": "1 colis | {count} colis",
    "pallet": "Palette | Palettes",
    "pallets": "1 palette | {count} palettes",
    "internationalParcel": "Colis international | Colis internationaux",
    "internationalParcels": "1 colis international | {count} colis internationaux",
    "overnightParcel": "Colis express | Colis express",
    "overnightParcels": "1 colis express | {count} colis express",
    "good": "Marchandise | Marchandises",
    "goods": "1 marchandise | {count} marchandises"
  },
  "bags": "1 bagage | {count} bagages",
  "cartons": "1 carton | {count} cartons",
  "newBooking": {
    "title": "Nouvelle réservation",
    "button": "Nouvelle réservation"
  },
  "editBooking": "Modifier la réservation",
  "errorOccured": "Une erreur s'est produite - veuillez réessayer",
  "errorCalculatingRoute": "Erreur lors du calcul de l'itinéraire",
  "addStop": "Ajouter un arrêt",
  "searchAddress": "Rechercher une adresse",
  "addressTypes": "Types d'adresse",
  "noBookingDetails": "Aucun détail de réservation disponible",
  "pickupDelay": "{dateString} (~{delay} min)",
  "performingQuote": "Calcul du devis en cours",
  "n/a": "Non disponible",
  "approx": "environ",
  "est": "Env.",
  "earliest": "Au plus tôt {dt}",
  "pickup": "Prise en charge {dt}",
  "arrive": "Arrivée {dt}",
  "back": "",
  "areYouSure": "Êtes-vous sûr ?",
  "alertBack": "Retour",
  "lastRefreshed": "Dernière actualisation : ",
  "storedAddressLabel": "Adresses",
  "deleteAddress": "Supprimer l'adresse",
  "noStoredAddressDetails": "Aucune adresse disponible",
  "alertFilter": "Filtrer",
  "alertYourAddresses": "Vos adresses",
  "alertAccountAddresses": "Adresses du compte",
  "alertRecentAddresses": "Adresses récentes",
  "groupYourAddresses": "Vos adresses",
  "groupAccountAddresses": "Adresses du compte",
  "groupRecentAddresses": "Adresses récentes",
  "buttonAddressBookFrom": "Réserver depuis...",
  "buttonAddressBookTo": "Réserver vers...",
  "buttonAddressEdit": "Modifier",
  "mapSearch": "Recherche sur la carte",
  "noAddressesFound": "Aucune adresse trouvée",
  "noCountriesFound": "Aucun pays trouvé",
  "save": "Enregistrer",
  "remove": "Supprimer",
  "signOutConfirmation": "Voulez-vous vous déconnecter ?",
  "exitAppConfirmation": "Voulez-vous quitter l'application ?",
  "minute": "min",
  "hour": "h",
  "booking": "Réservation",
  "noBookingTemplates": "Aucun modèle de réservation disponible",
  "reporting": {
    "title": "Rapports",
    "selectReport": "Sélectionner un rapport",
    "updateReportButton": "Mettre à jour le rapport",
    "noReportsAvailable": "Aucun rapport disponible",
    "noReportSelected": "Aucun rapport sélectionné",
    "filters": "Filtres du rapport",
    "export": {
      "copy": "Copier",
      "csv": "CSV",
      "xls": "Excel",
      "pdf": "PDF"
    }
  },
  "actions": "Actions",
  "noMop": "Aucun moyen de paiement disponible",
  "flightSearch": {
    "title": "Recherche de vol",
    "addFlightDetails": "Ajouter les détails du vol",
    "noFlightsFound": "Aucun vol trouvé",
    "flightWarning": "Avertissement concernant le vol",
    "airportArriveWarningMessage": "Veuillez vérifier le vol sélectionné, il ne semble pas arriver à l'aéroport que vous avez choisi",
    "airportDepartWarningMessage": "Veuillez vérifier le vol sélectionné, il ne semble pas partir de l'aéroport que vous avez choisi",
    "terminalArriveWarningMessage": "Veuillez vérifier le vol sélectionné, il ne semble pas arriver au terminal que vous avez choisi",
    "terminalDepartWarningMessage": "Veuillez vérifier le vol sélectionné, il ne semble pas partir du terminal que vous avez choisi",
    "matchFlightTimeHeader": "Aligner sur l'heure du vol ?",
    "matchFlightTimeMessage": "Souhaitez-vous aligner l'heure de la réservation sur l'heure d'arrivée du vol ?",
    "selectedAirport": "Aéroport sélectionné : {airportCode}",
    "flightAirport": "Aéroport du vol : {airportCode}",
    "flightTerminal": "Terminal du vol : {terminal}",
    "searchButton": "Rechercher des vols"
  },
  "to": "à",
  "from": "de",
  "noContactsFound": "Aucun contact trouvé",
  "maintainContact": "Gérer le contact",
  "bookAs": "Réserver en tant que",
  "leadPassenger": "Passager principal",
  "bookAsWarning": "Pour finaliser cette réservation, vous passerez en réservation au nom de {contactName}",
  "webAccess": {
    "addJobsMessage": "Désolé, vous n'avez pas les droits d'accès pour créer une réservation, veuillez appeler le {companyTelephoneNumber}",
    "editJobsMessage": "Désolé, vous n'avez pas les droits d'accès pour modifier cette réservation, veuillez appeler le {companyTelephoneNumber}",
    "cancelJobsMessage": "Désolé, vous n'avez pas les droits d'accès pour annuler cette réservation, veuillez appeler le {companyTelephoneNumber}",
    "addCardsMessage": "Désolé, vous n'avez pas les droits d'accès pour ajouter des cartes de paiement, veuillez appeler le {companyTelephoneNumber}",
    "editContactsMessage": "Désolé, vous n'avez pas les droits d'accès pour modifier ce contact, veuillez appeler le {companyTelephoneNumber}",
    "addAddressesMessage": "Désolé, vous n'avez pas les droits d'accès pour ajouter des adresses, veuillez appeler le {companyTelephoneNumber}",
    "editAddressesMessage": "Désolé, vous n'avez pas les droits d'accès pour modifier des adresses, veuillez appeler le {companyTelephoneNumber}",
    "deleteAddressesMessage": "Désolé, vous n'avez pas les droits d'accès pour supprimer des adresses, veuillez appeler le {companyTelephoneNumber}",
    "canRequestMessage": "Désolé, vous n'avez pas les droits d'accès pour demander un lien de contact, veuillez appeler le {companyTelephoneNumber}"
  },
  "approved": "Approuvé",
  "contactLink": {
    "contactLink": "Lien de contact",
    "linkNewContact": "Lier un nouveau contact",
    "linkedContacts": "Contacts liés",
    "noLinkedContacts": "Aucun contact lié",
    "pendingLinkedContacts": "Contacts liés en attente",
    "noPendingLinkedContacts": "Aucun contact lié en attente",
    "authoriseContactLink": "Autoriser le lien de contact ?",
    "confirmOrRejectContactLink": "Voulez-vous confirmer ou refuser ce lien de contact ?",
    "description": "Vous devez effectuer des réservations pour un collègue ou gérer son profil ? Demandez l'accès en saisissant son adresse e-mail ci-dessous, il recevra une notification indiquant que vous souhaitez accéder à son profil.",
    "pending": "En attente",
    "reject": "Rejeter"
  },
  "jobCalendar": {
    "eventTitle": "{companyName} : {firstStop} à {lastStop}",
    "pickup": "Prise en charge : {address}",
    "via": "Via : {address}",
    "dropOff": "Dépose : {address}",
    "journeyTime": "Durée estimée du trajet : {duration}",
    "trackingLink": "Suivez votre trajet : {url}"
  },
  "jobSharing": {
    "shareRideDetails": "Partager les détails du trajet",
    "iAm": "Je suis",
    "personIs": "{person} est",
    "shareMessage": "en trajet avec {companyName} de {firstStop} à {lastStop} le {dt}"
  },
  "noEditAccess": "Aucun droit de modification",
  "noBookingAccess": "Aucun accès à la réservation",
  "invalidBooking": "Détails de réservation invalides",
  "adminConsole": "Console d'administration",
  "cookieConsent": {
    "message": "Nous utilisons des cookies pour améliorer votre expérience et fournir des services essentiels. En continuant à naviguer sur notre site, vous consentez à l'utilisation de cookies. Pour en savoir plus, veuillez consulter notre",
    "privacyPolicy": "Politique de confidentialité",
    "accept": "Accepter",
    "dismiss": "Ignorer"
  },
  "eta": "Heure d'arrivée estimée : {eta}",
  "settings": "Paramètres",
  "language": "Langue",
  "appearance": {
    "label": "Apparence",
    "system": "Système",
    "light": "Clair",
    "dark": "Sombre"
  },
  "bookingButtons": {
    "addFavourite": "Ajouter aux favoris",
    "clearFavourite": "Retirer des favoris",
    "edit": "Modifier",
    "share": "Partager",
    "sendConfirmation": "Envoyer la confirmation",
    "copy": "Copier",
    "return": "Retour",
    "cancel": "Annuler",
    "addToCalendar": "Ajouter au calendrier",
    "more": "Plus"
  },
  "date": "Date",
  "time": "Heure",
  "price": {
    "taxIncluded": "(dont {tax} de TVA)",
    "saving": "Économie de {amount}"
  },
  "distance": {
    "outputText": "Distance {distance}",
    "extraText": "Veuillez noter que les distances de trajet ne sont que des estimations",
    "metresAway": "à {distance} mètres",
    "kilometresAway": "à {distance} km",
    "feetAway": "à {distance} pieds",
    "milesAway": "à {distance} miles",
    "miles": "{distance} mile | {distance} miles",
    "kilometres": "{distance} km"
  },
  "journey": {
    "outputText": "Trajet {journey}",
    "extraText": "Veuillez noter que les durées de trajet ne sont que des estimations"
  },
  "betweenTwoStrings": "Entre {first} et {second}",
  "quickQuote": "Devis",
  "bookingConfirmation": {
    "newTitle": "Réservation confirmée",
    "editTitle": "Réservation modifiée",
    "navigationCountdown": "Fermeture dans { secondsRemaining } s",
    "navigateButton": "Voir / gérer la réservation"
  },
  "savedJourneys": {
    "favTitle": "Trajets favoris",
    "noFavsMessage": "Aucun trajet favori disponible",
    "recentTitle": "Trajets récents",
    "noRecentsMessage": "Aucun trajet récent disponible",
    "stopsHeader": "Trajet",
    "tariffHeader": "Service",
    "goodsHeader": "Marchandises",
    "alert": {
      "addHeader": "Ajouter ce trajet aux favoris ?",
      "addMessage": "Ajoutez une description facultative du trajet",
      "editHeader": "Modifier la description",
      "editMessage": "Modifier la description facultative du trajet",
      "descriptionPlaceholder": "Description"
    }
  },
  "location": {
    "permissionMessage": "Pour nous permettre de trouver votre position actuelle, veuillez autoriser l'accès"
  },
  "documents": "Documents",
  "goodsFields": {
    "unitWeight": "Poids",
    "unitHeight": "Hauteur",
    "unitWidth": "Largeur",
    "unitDepth": "Profondeur",
    "unitValue": "Valeur",
    "unitCube": "Volume",
    "palletType": "Type de palette",
    "palletSubType": "Sous-type de palette",
    "nonDoc": "Hors document",
    "volumetricWeight": "Poids volumétrique"
  },
  "viewBooking": {
    "guestInfo": "Informations passager",
    "parcelInfo": "Informations colis",
    "palletInfo": "Informations palette",
    "journeyRouteMessage": "La carte ne représente qu'un exemple d'itinéraire et peut ne pas correspondre exactement à celui emprunté par le chauffeur.",
    "jobFlags": "Options",
    "jobExtras": "Suppléments",
    "jobRefs": "Références",
    "driverPhoto": "Photo du chauffeur",
    "vehicleImage": "Image du véhicule",
    "tariffImage": "Image du service",
    "proofOfDelivery": "Preuve de livraison",
    "webInstructions": "Notes pour le chauffeur",
    "price": "Prix",
    "netPrice": "Prix net",
    "tax": "TVA",
    "totalPrice": "Prix total"
  },
  "dateRelative": {
    "lastWeek": "eeee 'dernier à' p",
    "yesterday": "'Hier à' p",
    "today": "'Aujourd''hui à' p",
    "tomorrow": "'Demain à' p",
    "nextWeek": "eeee 'à' p",
    "other": "P 'à' p"
  },
  "payment": {
    "cards": "Cartes de paiement",
    "noCards": "Aucune carte de paiement disponible",
    "bookingPaymentTitle": "Paiement de la réservation",
    "withCardEnding": "avec la carte se terminant par {cardNum}",
    "cardValidFrom": "valable du",
    "cardValidTo": "valable jusqu'au",
    "addCard": "Ajouter une carte",
    "deleteCard": "Supprimer la carte",
    "makeDefaultCard": "Définir comme carte par défaut",
    "pay": "Payer",
    "savedCards": "Cartes enregistrées",
    "otherPaymentMethod": "Autre moyen",
    "adflexNavWarning": "Si vous avez déjà effectué un paiement, celui-ci vous sera tout de même débité"
  },
  "profileContact": {
    "telephone": "Téléphone",
    "mobile": "Mobile",
    "account": "Compte"
  }
}
